import { render, staticRenderFns } from "./SlashList.vue?vue&type=template&id=da38987a&"
import script from "./SlashList.vue?vue&type=script&lang=ts&"
export * from "./SlashList.vue?vue&type=script&lang=ts&"
import style0 from "./SlashList.vue?vue&type=style&index=0&id=da38987a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports